import React, {Component, Fragment} from "react";
import * as R from "ramda";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import Api from "../../../../Services/Api";
import {mapToDDL} from "../../../common/mapper";
import FlexView from "react-flexview";

class MasterCOAHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAllSelected: false,
            isSpecificSelected: false,
            dataCabang: [],
            dataVariant: [],
        };
    }

    componentDidMount() {
        this.fetchDataCabang();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if (
        //     prevProps.controls.packageAllCabang?.value !== this.props.controls.packageAllCabang?.value ||
        //     prevProps.controls.packageSpecificCabang?.value !== this.props.controls.packageSpecificCabang?.value
        // ) {
        //     this.setState((prevState) => ({
        //         ...prevState,
        //         isAllSelected: this.props.controls.packageAllCabang?.value,
        //         isSpecificSelected: this.props.controls.packageSpecificCabang?.value,
        //     }))
        // }
    }

    handleSelectedBranch = (e, type) => {
        // const isChecked = e.target.checked;

        // if (type === "all") {
        //     this.setState((prevValue) => ({
        //         ...prevValue,
        //         isAllSelected: isChecked,
        //         isSpecificSelected: false,
        //     }));
        //     this.props.setValue("listCabang", []);
        //     this.props.setValue("packageAllCabang", isChecked);
        //     this.props.setValue("packageSpecificCabang", false);
        // }

        // if (type === "specific") {
        //     this.setState((prevValue) => ({
        //         ...prevValue,
        //         isSpecificSelected: isChecked,
        //         isAllSelected: false,
        //     }));
        //     this.props.setValue("packageSpecificCabang", isChecked);
        //     this.props.setValue("packageAllCabang", false);
        // }
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: res.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    render() {
        return (
            <Fragment>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <SimpleInput
                            id="input_text_coaID"
                            name="coaId"
                            label="ID COA"
                            mandatory
                            readOnly
                            errorMessage={this.props.errors.coaId}
                            value={this.props.controls.coaId?.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="select_options_coaName"
                            name="coaName"
                            label="Nama COA"
                            mandatory
                            errorMessage={this.props.errors.coaName}
                            value={this.props.controls.coaName?.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        
                    </div>
                    <div id="grid-2">
                       <SimpleDDL
                            id="select_options_kodeCabang"
                            name="masterCoaCabangDTOS"
                            label="Cabang Berlaku"
                            box="multiselect"
                            mandatory
                            options={this.state.dataCabang.map(item => mapToDDL(item.namaDealer, item.kodeCabang))}
                            errorMessage={this.props.errorListCabang}
                            value={this.props.controls.masterCoaCabangDTOS?.value}
                            onChange={(value, {name}) =>
                                this.props.setValue(name, value)
                            }
                        />
                        
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default MasterCOAHeader;